// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactHubModal-cls1_p9I","cls2":"ImpactHubModal-cls2_1GM ImpactHubModal-cls1_p9I"};